import useSWR from 'swr';
import { useCustomMutation } from '../../utils/useCustomMutation';
import { Loading, Toggle } from 'carbon-components-react';
import { postMethod } from '../../api/common';
import { ConfirmModal } from '../../components/modal/confirm-modal/ConfirmModal.component';

export function LinkSBAToGradingModal({ isOpen, closeModal }) {
  return (
    <ConfirmModal
      title="Use SBA For Class Score"
      isOpen={isOpen}
      closeModal={closeModal}
      secondaryActionText="Close"
      secondaryBtnClasses="secondary"
      description={
        <>
          <LinkSBAToGrading isOpen={isOpen} />
        </>
      }
    />
  );
}

export function LinkSBAToGrading({ isOpen }) {
  const { data, mutate, isLoading } = useSWR(
    isOpen ? `academic/grading/retrieve-sba-configuration` : null,
  );

  const linkSbaToGrading = data?.response?.useSBAForClassScore;

  const { trigger, isMutating, error } = useCustomMutation(
    `academic/grading/update-sba-configuration`,
    (url, { arg }) => postMethod(url, arg),
  );

  const isRunning = isLoading || isMutating;
  return (
    <div>
      <div
        className="mt-30 d-flex-space-between"
        style={{
          gap: '10px',
          alignItems: 'center',
        }}
      >
        <p>Use SBA For Class Score</p>
        <div
          style={{
            maxWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          {isRunning ? (
            <Loading
              small={true}
              withOverlay={false}
              style={{ alignSelf: 'end', marginBottom: '4px' }}
            />
          ) : (
            <div style={{ marginTop: '-20px' }}>
              <Toggle
                size="md"
                id="linkSbaToGrading"
                labelText=""
                labelA=""
                labelB=""
                toggled={linkSbaToGrading}
                onToggle={(value) => {
                  trigger(
                    {
                      useSBAForClassScore: value,
                    },
                    {
                      onSuccess: () => {
                        mutate();
                      },
                    },
                  );
                }}
              />
            </div>
          )}
        </div>
      </div>

      {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}
    </div>
  );
}
